import { cva, type VariantProps } from 'class-variance-authority'

/**
 * Card variants - Pentru containere produse, info boxes, grid items
 *
 * Design tokens from tailwind.config.js:
 * - cards-bg (#F5F5F5) - Card background color
 * - card (hsl CSS var) - shadcn/ui card background
 * - card-foreground (hsl CSS var) - shadcn/ui card text
 */
export const cardVariants = cva(
  'rounded border bg-card text-card-foreground',
  {
    variants: {
      variant: {
        default: '',

        // Product cards (33 utilizări totale bg-cards-bg)
        productInfo: 'bg-cards-bg p-5 flex flex-col justify-start',
        productInfoAlt: 'bg-cards-bg px-5 pt-3 xl:bg-inherit xl:px-0 xl:pt-0',
        productContainer: 'bg-cards-bg border-solid border-y-4 border-white xl:border-0',

        // Grid items (4 duplicări identice în sliders)
        gridItem: 'bg-cards-bg px-1 py-2',
      },
      spacing: {
        default: 'p-6',
        tight: 'p-3',
        loose: 'p-5',
        none: 'p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
      spacing: 'default',
    },
  }
)

export const cardContentVariants = cva(
  'p-6 pt-0',
  {
    variants: {
      padding: {
        default: 'p-6 pt-0',
        tight: 'p-3 pt-0',
        none: 'p-0',
      },
    },
    defaultVariants: {
      padding: 'default',
    },
  }
)

export type CardVariants = VariantProps<typeof cardVariants>
export type CardContentVariants = VariantProps<typeof cardContentVariants>
